import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { errorMessage } from './format';

const saveBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Download a daily report PDF built by the backend. Pass the same params the
 * page loads the report with, so the PDF matches what is on screen.
 */
export default function useReportPdf(download) {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPdf = useCallback(
    async (params) => {
      setIsDownloading(true);
      try {
        const { blob, filename } = await download(params);
        saveBlob(blob, filename);
      } catch (error) {
        toast.error(errorMessage(error, 'Could not create the PDF. Please try again.'));
      } finally {
        setIsDownloading(false);
      }
    },
    [download]
  );

  return { downloadPdf, isDownloading };
}
